<template>
    <div>
        <v-row dense class="ml-0 mb-3">
            <v-col cols="12">
                {{ this.title }}
                <v-avatar size="20" color="success" class="avatar-ptr ml-4" v-on:click="addEmptyComponent()">
                    <v-icon small color="white">mdi-plus</v-icon>
                </v-avatar>
            </v-col>
        </v-row>
        <div v-for="(component, key) in components" :key="key">
            <v-row cols="12" dense class="mr-6">
                <v-col cols="9">
                    <v-text-field v-model="component.description" label="Description goes here" single-line dense></v-text-field>
                </v-col>
                <v-col cols="2">
                    <input_amount_array label="" prefix="€" :element="key" :amount="component.amount" field="amount" @updateData="updateComponentAmount" class="pl-2"/>
                </v-col>
                <v-col cols="1" class="d-flex justify-end">
                    <v-btn icon x-small v-on:click="clearComponent(component.key)" class="margin-btn">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <span>
                        <v-btn icon x-small v-on:click="deleteComponent('key', component.key)" class="margin-btn">
                            <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </span>
                </v-col>
            </v-row>
        </div>
        <span v-if="this.components != null && this.components.length > 0">
            <v-row dense no-gutters class="ml-6 mr-6">
                <v-col cols="2" offset="9" class="pr-2 pl-2">
                    <input_amount label="" prefix="€" :amount="totCompAmount" :isReadOnly="true" field="totCompAmount"/>
                </v-col>
            </v-row>
        </span>
    </div>
</template>

<script>

import input_amount_array from '@/components/ui/input_amount_array.vue';
import input_amount from '@/components/ui/input_amount.vue';

// watcher maken op de array, als die veranderd dan emiten
export default {
    watch:{
        components: {
            deep: true,
            handler(){
              this.$emit('updateData', {field: 'components', value: this.components});
            } 
        },
    },
    props: {
        components: {
            type: Array,
            default: function() { return [{key: '', description: '', amount: ''}]; },
        },
        title: String
    },  
    components: {
        input_amount_array,
        input_amount
    },  
    computed: {
      totCompAmount: function(){
        var total = 0;
        this.components.forEach(function (x){
            total += +((""+x.amount).replace(".", "")).replace(",", ".");
        });
        return this.toDutchNumberFormat(total);        
      },
    },         
    data() {
        return {
        }
    },
    methods: {
        addEmptyComponent(){
            let key = 0;
            if (this.components !== null) {
                key = this.components.length;
            }
            let component = new Object();
            component.key = key;
            component.description = '';
            component.amount = '';
            this.components.push(component);
        },
        clearComponent(attr_value) {
            let idx = this.findWithAttr(this.components, "key", attr_value);
            this.components[idx].description = '';
            this.components[idx].amount = '';
        },
        deleteComponent(attr, attr_value) {
            let idx = this.findWithAttr(this.components, attr, attr_value);
            if (idx !== -1) {
                this.components.splice(idx, 1);
            }
        },        
        findWithAttr(array, attr, value) {
            for(let i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        },         
        toDutchNumberFormat(value) {
            if(value != null && value != '' && value != '0') {    
                if((""+value).includes(",")) { 
                    value = ((""+value).replace(".", "")).replace(",", "."); 
                } 
                return new Intl.NumberFormat('nl-NL', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(+value);
            } else {
                return '0';
            }
        },            
        updateComponentAmount(v){
            this.components[v.element].amount = v.value;
        }
    }
}    
</script>

<style scoped>
    .avatar-ptr {
        cursor: pointer;
    }
    .margin-btn {
        margin-top: 10px;
        margin-left: 10px;
    }    
    .text-grey {
        color: grey !important;
        font-weight: 400 !important;
        /* 800 being bold so this is half bold */
    }    
    .text-field-style>>>.v-text-field__slot input {
        color: grey;
        font-weight: 300;
        /* 800 being bold so this is less than half bold */
    }    
</style>